/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Preset_YesterdayInputs */

const vi_warehouse_sales_preset_yesterday = /** @type {(inputs: Warehouse_Sales_Preset_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hôm qua`)
};

/**

* @param {Warehouse_Sales_Preset_YesterdayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_preset_yesterday = /** @type {((inputs?: Warehouse_Sales_Preset_YesterdayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Preset_YesterdayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_preset_yesterday(inputs)
});